import { PortalChangePassword } from "@/features/portal/components/auth/portal-change-password";

/** `/portal/password` — change the portal password. */
export default function ChangePasswordPage() {
  return <PortalChangePassword />;
}
